import axios from './axios';

export const devicesAPI = {
  getAll: async (params = {}) => {
    const response = await axios.get('/devices/', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await axios.get(`/devices/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await axios.post('/devices/', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await axios.put(`/devices/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await axios.delete(`/devices/${id}`);
    return response.data;
  },

  uploadImage: async (id, file) => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await axios.post(`/devices/${id}/image`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  deleteImage: async (id) => {
    const response = await axios.delete(`/devices/${id}/image`);
    return response.data;
  }
};
